import React, { FC } from 'react';
import { Route, Router, Switch, useHistory } from 'react-router';

import { HtmlReport } from 'src/apps/mobile-common/pages/html-report/HtmlReport';
import { useSetMobileSdkV1Breadcrumbs } from 'src/apps/mobile-sdk-v1/hooks/useSetMobileSdkV1Breadcrumbs';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { ProductType } from 'src/common/interfaces/Tenant';
import { useUserTenant } from 'src/common/providers/userTenantProvider/UserTenantProvider';
import { hasLicenseForProduct } from 'src/common/services/CommonDashboardService';

import { NotFound404Page } from '../../../common/pages/not-found-404-page/NotFound404Page';
import { Unauthorized403Page } from '../../../common/pages/unauthorized-403-page/Unauthorized403Page';
import { getMsdkReportIdParam } from '../../../common/services/breadcrumbs/MsdkUrlService';
import { DashboardContainerMobileSDK } from '../pages/dashboard-container/DashboardContainerMobileSdk';

const productType = ProductType.MOBILE_SDK;

const MobileSdkV1TestReportGate: FC = () => {
	const { tenant } = useUserTenant();
	const { location } = useHistory();
	const hasLicense = hasLicenseForProduct(tenant, productType);

	const sessionId = getMsdkReportIdParam(location);

	useSetMobileSdkV1Breadcrumbs();

	return hasLicense ? <HtmlReport sessionId={sessionId} msdkReport /> : <Unauthorized403Page />;
};

export const MobileSdkV1Router: FC = () => {
	const history = useHistory();

	return (
		<Router history={history}>
			<Switch>
				<Route
					exact
					path={RoutesHelper.getMobileSdkV1DashboardPath()}
					component={DashboardContainerMobileSDK}
				/>
				<Route
					exact
					path={RoutesHelper.getMobileSdkV1TestReportPathname()}
					render={() => <MobileSdkV1TestReportGate />}
				/>
				<Route render={() => <NotFound404Page />} />
			</Switch>
		</Router>
	);
};
